import React from "react";
import { NavLink } from "react-router-dom";
import { EncodeToBase64 } from '../../../helpers/tools';

export default function ItemLink ({ pagina }) {

    const url = EncodeToBase64(pagina.url);

    const handleSetApp = (app) => {
        sessionStorage.setItem("appActual", app);
    }
    

    return (
        <NavLink
            style={({
                color: "black",
                display: "block",
                fontSize: "10pt",
                margin: "0px 10px",
                textDecoration: "none",
                width: 140,
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
            })}
            to={ "/menu/" + url }
            key={ pagina.idApp }
            onClick={() => {
                handleSetApp(pagina.descripcion)
            }}
            >
            { pagina.descripcion }
        </NavLink>
    );
};